module.exports = __webpack_public_path__ + "static/media/xdai.3ab0ed5c.svg";